
































































import { Vue, Component, Prop,  Watch, Ref } from 'vue-property-decorator'
import { Fragment } from 'vue-fragment'
import {
	AtributoDoProduto,
	Variacao,
	Variante,
	Produto,
	Atributo,	
	FormProduto,
} from '@/models'
import type { FormProdutoSimplesComVariantes } from '@/models'
import CamposDeAtributoDoProduto from './CamposDeAtributoDoProduto.vue'
import cartesianProduct from 'cartesian-product'
import { FindAtributoUseCase } from '@/usecases/produto/FindAtributoUseCase'
import { completarAtributosDoProdutoComAsVariantes, displayVariantes, mesclarGradesDeAtributosVariantes, normalizarValorDeAtributo, normalizarValoresDosAtributosDoProduto } from '@/shareds/produto-shareds'
import PanelDeEdicaoDaVariante from './PanelDeEdicaoDaVariante.vue'
import { v4 as uuidv4 } from 'uuid'
import DialogoDeSelecaoDeGradeDeProdutos from '@/components/produto/DialogoDeSelecaoDeGradeDeProdutos.vue'

@Component({
	components: {
		Fragment,
		CamposDeAtributoDoProduto,
		PanelDeEdicaoDaVariante,
		DialogoDeSelecaoDeGradeDeProdutos,
	},
})
export default class CamposDeProdutoComVariantes extends Vue {
	@Prop() value!: FormProdutoSimplesComVariantes
	@Prop({ type: Boolean, default: false }) skuAutomatico!: boolean
	@Ref() dialogoDeSelecaoDeGradeDeProdutos!: DialogoDeSelecaoDeGradeDeProdutos
	opcoesDeAtributos: Atributo[] = []
	
	expandido = false

	findOpcaoDeAtributo = new FindAtributoUseCase()
	displayVariantes = displayVariantes
	apresentarCampoDeAtributo = false

	set produto(produto: CamposDeProdutoComVariantes['value']) {
		this.$emit('input', produto)
	}

	get produto() {
		return this.value
	}

	atualizarVariante(indice: number, valor: any) {
		this.value.variantes.splice(indice, 1, valor)
	}

	async created() {
		this.opcoesDeAtributos = await this.findOpcaoDeAtributo.findAll()

		normalizarValoresDosAtributosDoProduto(this.produto.atributosProduto)

		completarAtributosDoProdutoComAsVariantes(
			this.produto.atributosProduto,
			this.produto.variantes,
			this.opcoesDeAtributos,
		)

		if (this.isNovoProduto) {
			const jaTemAtributosComValores = this.produto.atributosProduto
				?.some(a => (a.valores?.length ?? 0) > 0)
			if (!jaTemAtributosComValores) {
				this.garantirCorETamanhoPadrao()
			}
		}
	}

	get atributosSelecionadas() {
		return this.produto.atributosProduto.map(({ atributo }) => atributo)
	}

	excluirVariante(indice: number) {
		this.produto.variantes.splice(indice, 1)
		
	}

	excluirAtributo(indice: number) {
		this.produto.atributosProduto.splice(indice, 1)
	}

	get gradeTotal() {
		return this.criarVariantesDoProduto(
			this.produto as Produto,
			this.produto.atributosProduto as AtributoDoProduto[],
		)
	}

	criarVariantesDoProduto(
		produto: Produto,
		atributos: AtributoDoProduto[],
	) {
		const atributosDaVariante = atributos
			.map(atributoDoProduto => ({
				...atributoDoProduto,
				valores: (atributoDoProduto.valores || [])
					.map(normalizarValorDeAtributo)
					.filter(valor => !!valor),
			}))
			.filter(({ valores }) => valores.length)
			.map(({ atributo, valores }) =>
				valores.map(valor => ({
					id: uuidv4(),
					nome: atributo.nome,
					valor,
				})),
			)
		const variacoes: Variacao[] = cartesianProduct(atributosDaVariante)
		const variantes = variacoes.map<FormProduto>(variacao => {
			const skuGerado = this.gerarSkuDaVariante(produto, variacao)
						
			return {
				id: '',
				ncm: null,
				cest: null,
				regraFiscal: null,
				idProdutoPai: produto.id,
				tipo: 'Variante',
				tags: produto.tags,
				descricao: null,
				categoria: produto.categoria,
				urlImagens: produto.urlImagens,
				sku: skuGerado,
				preco: null,
				pesoLiquido: produto.pesoLiquido,
				pesoBruto: produto.pesoBruto,
				descontoVarejo: null,
				marca: produto.marca,
				nome: produto.nome,
				nomeCompleto: `${produto.nome} ${this.formarNomeDaVariacao(variacao)}`,
				atributosVariante: variacao.map(v => {return { ...v, id: v.id = uuidv4() }}),
				temGarantia: produto.temGarantia,
				regrasFiscais: [],
				eans: [],
				unidadeDeMedida: produto.unidadeDeMedida,
				identificadores: [],
				produtoDesativado: produto.produtoDesativado,
				produtoIntegrado: produto.produtoIntegrado,
				genero: produto.genero,
				fatorDeConversao: produto.fatorDeConversao,
				unidadeDeConversao: produto.unidadeDeConversao,
				estacao: produto.estacao,
				isValePresente: false,
				skuPai: produto.skuPai,
				quantidadeImportacao: null,
				fornecedor: produto.fornecedor,
				precoCompra: null,
				margemLucro: null,
				familiasDoProduto: produto.familiasDoProduto,
				tipoDaOrigemDoProduto: produto.tipoDaOrigemDoProduto,
				codigoOrigemDoProduto: produto.codigoOrigemDoProduto,
			}
		})
		return variantes
	}

	@Watch('gradeTotal')
	onChangeGradeTotal(gradeTotal: CamposDeProdutoComVariantes['gradeTotal']) {
		this.produto.variantes = JSON.parse(JSON.stringify(mesclarGradesDeAtributosVariantes(this.produto.variantes as Variante[] , gradeTotal as Variante[], this.skuAutomatico)))
	}

	formarNomeDaVariacao(variacao: Variacao) {
		return variacao.map(atributo => atributo.valor).join(' / ').toUpperCase()
	}

	async deletaVariante(idVariante: string | undefined) {
		if (!idVariante) return
		this.produto.variantes = this.produto.variantes.filter(
			variante => variante.id !== idVariante,
		)
	}

	gerarSkuDaVariante(produto: Produto, variacao: Variacao): string {
		const skuBase = produto.sku || produto.nome?.replace(/\s+/g, '').toUpperCase() || 'PROD'
		
		const cor = variacao.find(v => v.nome === 'Cor')?.valor
		const tamanho = variacao.find(v => v.nome === 'Tamanho')?.valor
		
		const partes = [skuBase]
		
		if (cor) {
			const corLimpa = cor
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')
				.toUpperCase()
				.replace(/\s+/g, '')
			partes.push(corLimpa)
		}
		
		if (tamanho) {
			const tamanhoLimpo = tamanho
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')
				.toUpperCase()
				.replace(/\s+/g, '')
			partes.push(tamanhoLimpo)
		}
		
		return partes.join('')
	}

	montarGradeDoProduto() {
		this.dialogoDeSelecaoDeGradeDeProdutos.mostrar()
	}

	async criarVariacoesDoProdutoEmEdicao(cores, tamanhos) {
		const atributosCor = this.produto.atributosProduto.find(a => a.atributo?.nome === 'Cor')
		const atributosTamanho = this.produto.atributosProduto.find(a => a.atributo?.nome === 'Tamanho')

		const coresUpper = cores.map(c => normalizarValorDeAtributo(c).trim().toUpperCase())
		const tamanhosUpper = tamanhos.map(t => normalizarValorDeAtributo(t).trim().toUpperCase())

		if (atributosCor) {
			const atuais = (atributosCor.valores ?? []).map(v => normalizarValorDeAtributo(v).trim().toUpperCase())
			atributosCor.valores = [...new Set([...atuais, ...coresUpper])].filter(valor => !!valor)
		}

		if (atributosTamanho) {
			const atuais = (atributosTamanho.valores ?? []).map(v => normalizarValorDeAtributo(v).trim().toUpperCase())
			atributosTamanho.valores = [...new Set([...atuais, ...tamanhosUpper])].filter(valor => !!valor)
		}
	}

	get isNovoProduto() {
		return !this.produto?.id || this.produto.id === ''
	}

	garantirCorETamanhoPadrao() {
		const cor = this.opcoesDeAtributos.find(a => a.nome === 'Cor') ?? { id: '', nome: 'Cor' }
		const tamanho = this.opcoesDeAtributos.find(a => a.nome === 'Tamanho') ?? { id: '', nome: 'Tamanho' }

		const base = () => ({
			id: '',
			atributo: null,
			valores: [],
			descontoVarejo: 0,
		})

		this.produto.atributosProduto = [
			{ ...base(), atributo: cor },
			{ ...base(), atributo: tamanho },
		]
	}

	get temCor() {
		return this.produto.atributosProduto.some(a => a.atributo?.nome === 'Cor')
	}

	get temTamanho() {
		return this.produto.atributosProduto.some(a => a.atributo?.nome === 'Tamanho')
	}

}
